// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__17DJk","empty":"ModalGraph_empty__32cK8"};